// extracted by mini-css-extract-plugin
export default {"productIcon":"ProductIcon_productIcon__fywRn"};